
import CheckIcon from 'vux/src/components/check-icon/index.vue'

import Popup from 'vux/src/components/popup/index.vue'

import XTable from 'vux/src/components/x-table/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Search from 'vux/src/components/search/index.vue'


export default {
name: "biz-browse",
components: {
Popup,
CheckIcon,
XTable,
PopupHeader,
Search
},
data() {
return {
value: null,
divMask: null,
wlPopup: null,
list: [],
show: false,
showBottom: false,
page: 0,
chooseData: null,
searchRules: [],
browseObj: {
searchCondition: {}
},
idField:'id',
showField:null
}
},
props: ['multiple', 'searchBaseData', 'valueText', 'bizObject'],
methods: {

showPop() {
this.show = true;
if (this.show) {
this.page = 0;
this.showBottom = false;
this.value = null;
this.list = [];
this.chooseData = null;
this.getList();
}
this.getElement()
},
delSearch() {
this.$emit('on-clear')
},
clear() {
this.value = null;
this.searchRules = [];
this.getList();
},
getList() {
if (this.value) {
this.searchRules = [{field:this.browseObj.searchCondition['value'],option: 'LIKE_ANYWHERE',values: [this.value], collectIndex: -1}];
} else {
this.searchRules = [];
}
this.$loadingShow();
this.$post(this.browseObj.url,{number:0,size: 10,rules:this.searchRules}).then((res) => {
this.$loadingHide();
const data = res.content.filter((item) => {
return !item.deleted;
});
this.list = this.list.concat(data);
if (data.length < 10) {
this.showBottom = true;
} else {
this.showBottom = false;
}
}).catch(() => {
this.$loadingHide();
});
},
getMore() {
this.page++;
if (this.value) {
this.searchRules = [{field:this.browseObj.searchCondition['value'],option: 'LIKE_ANYWHERE',values: [this.value], collectIndex: -1}];
} else {
this.searchRules = [];
}
this.$loadingShow();
this.$post(this.browseObj.url,{number:this.page,size: 10,rules:this.searchRules}).then((res) => {
this.$loadingHide();
const data = res.content.filter((item) => {
return !item.deleted;
});
this.list = this.list.concat(data);
if (data.length < 10) {
this.showBottom = true;
} else {
this.showBottom = false;
}
}).catch(() => {
this.$loadingHide();
});
},

searchList() {
this.page = 0;
this.list = [];
this.chooseData = null;
this.getList();
},

choose(data) {
if (this.multiple) {
if (data.checkSelected) {
if (!this.chooseData) {
this.chooseData = [];
}
this.chooseData.push(data);
} else {
let dataList = [];
for (let i = 0; i < this.chooseData.length; i++) {
if (data.id !== this.chooseData[i].id) {
dataList.push(this.chooseData[i]);
}
}
this.chooseData = dataList;
}
} else {
if (data.checkSelected) {
if (this.chooseData) {
this.$set(this.chooseData, 'checkSelected', false);
}
this.chooseData = data;
} else {
this.chooseData = null;
}
}
},

goBack() {
let resultData;
if (this.multiple) {
if (!this.chooseData || !this.chooseData.length) {
this.$vux.toast.text('请选择数据');
return;
}
resultData = {};
let idList = [];
let showList = [];
this.chooseData.forEach((item) => {
idList.push(item[this.idField]);
showList.push(item[this.showField]);
});
const idStr = idList.join(',');
const showStr = showList.join(',');
resultData = {
idValue:idStr,
showValue:showStr
}
} else {
if (!this.chooseData) {
this.$vux.toast.text('请选择数据');
return;
}
resultData = {
idValue:this.chooseData[this.idField],
showValue:this.chooseData[this.showField]
};
}
this.$emit('on-confirm',resultData);
this.show = !this.show;
},
hide() {
let popup = document.getElementById(this.wlPopup);
popup.parentElement.removeChild(this.divMask);
},
getElement() {
this.$nextTick(() => {
let el = document.getElementsByClassName('vux-popup-mask vux-popup-show')[0];
if (el) {
document.body.removeChild(el)
}
let popup = document.getElementById(this.wlPopup);
this.divMask = document.createElement('a');
this.divMask.className = 'vux-popup-mask';
this.divMask.dataset.uuid = '';
this.divMask.href = 'javascript:void(0)';
this.divMask.style.opacity = 1;
this.divMask.style['z-index'] = 1;
this.divMask.addEventListener('click', () => {
this.show = false;
}, false);
popup.parentElement.appendChild(this.divMask)

})
},
getBrowseObj() {
this.$get(`api/component-config/name/${this.bizObject}`).then((res) => {
let obj = JSON.parse(res.configData);


this.showField = obj.showField;

if (obj.idField) {
this.idField = obj.idField;
}
this.browseObj.url = obj.url;
if(this.browseObj.url.indexOf('/page') === -1){
this.browseObj.url += '/page';
}
if(obj.topSearchCriteria && obj.topSearchCriteria[0]){
this.browseObj.searchCondition = {label:obj.topSearchCriteria[0].placeholder || obj.topSearchCriteria[0].label,value:obj.topSearchCriteria[0].searchName}
}
if(obj.colModelsContract && obj.colModelsContract.length){
this.browseObj.item = [];
obj.colModelsContract.forEach((item) => {
let inputItem = {
label:item.label,
value:item.name
};
this.browseObj.item.push(inputItem);
})
}
})
}
},
mounted() {
this.wlPopup = (Math.random() + 1) * 10 + 'red';
this.getBrowseObj();
}
}



// WEBPACK FOOTER //
// ./src/components/biz-browse.vue